import DeleteDocumentIcon from "./DeleteDocumentIcon";

export default DeleteDocumentIcon;
